/* eslint-disable max-len */
const SupportaSymbol = () => (
  <svg data-name="Laag 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g>
      <path d="M22.14,3.88c-1.2-1.2-2.78-1.86-4.48-1.86s-3.28.66-4.49,1.86l-5.62,5.68c-.66.66-1.74.66-2.4,0-.32-.32-.5-.75-.5-1.2s.17-.88.5-1.2c.4-.4.97-.57,1.49-.47.74.13,1.49-.1,2.02-.64l.02-.02c1.29-1.29.65-3.55-1.14-3.89-2-.38-4.13.2-5.67,1.74-1.2,1.2-1.86,2.78-1.86,4.48,0,1.61.6,3.11,1.67,4.28l.38.38c2.48,2.29,6.36,2.23,8.78-.18l5.62-5.68c.65-.65,1.77-.65,2.4,0,.32.32.5.75.5,1.2s-.17.88-.5,1.2l-8.5,8.5c-.9.9-.9,2.36,0,3.26l.02.02c.9.9,2.36.9,3.26,0l8.5-8.5c1.2-1.2,1.86-2.78,1.86-4.48s-.66-3.28-1.86-4.48Z" fill="currentColor" strokeWidth="0" />
    </g>
  </svg>
);

export default SupportaSymbol;
